import { FC } from 'react'

const RightToolbar: FC = () => {
  return null;
}

export { RightToolbar }
